<template>
  <div class="card-bg-details shadow">
    <div class="card-body-track pb-1">
      <div v-if="trackFiles">
        <p class="">Tracks ({{ trackStems.length }})</p>

        <div class="upload-item-box my-2">
          <uploadItem class="my-2" v-for="stem in trackStems" :key="stem.id" :name="stem.stemname" :url="stem.stemurl" />
        </div>
      </div>
      <div v-else></div>
      <div v-if="refFiles">
        <p class="">Reference ({{ refStems.length }})</p>
        <div class="upload-item-box my-2">
          <uploadItem class="my-2" v-for="stem in refStems" :key="stem.id" :name="stem.stemname" :url="stem.stemurl" />
        </div>
      </div>
      <div v-else></div>

      <div class="w-100 d-flex justify-content-between align-items-center">
        <div>
          <p class="">
            Final Mix ({{ trackStatus === "Complete" ? finalMixes.length : "0" }})
          </p>
        </div>
        <div v-if="approveStatus == 1 && finalStems.length > 0" class="d-stem-box">
          <a :href="finalStems[0].trackurl" class="d-stem-btn">Download Stem</a>
        </div>
        <div v-else></div>
      </div>

      <div>
        <div class="upload-item-box my-2" v-if="trackStatus === 'Complete'">
          <finalItem class="my-2" v-for="final in finalMixes" :key="final.trackurl" mix="final" name="Final Mix" :id="id"
            :url="final.trackurl" :approved="approveStatus" />
        </div>
        <div class="upload-item-box my-2" v-else>No Final Tracks</div>
      </div>
    </div>
  </div>
</template>

<script>
import uploadItem from "@/components/UploadsItem.vue";

import finalItem from "@/components/FinalMixItem.vue";
export default {
  components: { uploadItem, finalItem },
  props: {
    refStems: Array,
    trackStems: Array,
    details: Object,
    finalMixes: Array,
    finalStems: Array
  },
  data() {
    return {
      finalStem: [],
      trackName: this.details.trackname,
      refiles: [],
      id: this.$route.params.id,
    };
  },
  computed: {
    approveStatus() {
      return this.details.approved;
    },
    trackStatus() {
      return this.details.status;
    },
    trackFiles() {

      return this.trackStems.length > 0 ? 1 : 0;
    },
    refFiles() {
      return this.refStems.length > 0 ? 1 : 0;
    },
  },
  methods: {
    submitRemix() {
      this.$store.dispatch("apiEvents/useRevisionCredit").then(() => {
        this.$store.dispatch("trackData/sendRemixData").then(() => { });
      });
    },
  },
  mounted() {
    this.$store.dispatch(
      "trackData/fetchRemixesByTrackId",
      this.$store.state.trackData.currentTrackId
    );
  },
};
</script>

<style scoped>
.d-stem-btn,
.d-stem-btn:hover {
  color: #2bfed1;
  font-size: 14px;
  text-decoration: none;
}

.d-stem-box {
  padding: 5px 10px 5px 10px;
  border-radius: 20px;
  border: 1px solid #2bfed1;
  transition: 0.1s ease-in-out;
}

.d-stem-box:hover {
  background-color: #2bfed024;
  border: 1px solid #2bfed024;
}

.upload-item-box {
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
